module.exports = __webpack_public_path__ + "img/bed96f7.jpg";